/**
 * Représente un événement clic sur un élément du menu contextuel des templates de mail.
 */
export class TemplateContextMenuItemEvent {
	/**
	 * Constructeur.
	 * @param variable : Variable à insérer.
	 * @param source : Source du menu contextuel (Composant pour lequel le menu contextuel a été affiché).
	 */
	constructor(
		public variable: string,
		public source: string
	) {}
}
